export const canchas = [
    { name: "Bahiense del Norte 1" },
    { name: "Bahiense del Norte 2" },
    { name: "Bahiense del Norte 3" }
];